<template>
  <div>
    <top-navbar></top-navbar>
    <div class="project-dashboard">
      <h6 class="manage-boder pt-2 font1 decoration">
        <router-link class="decoration" to="/">Home</router-link>
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Projects
        <span class="pfimg3"><i class="fa fa-angle-right"></i></span>
        Dashboard
      </h6>

      <div class="container-fluid dashboard-content">
        <div v-if="errorMessage" class="alert alert-danger">
          {{ errorMessage }}
        </div>
        <div v-if="loading" class="dashboard-loading">
          <div class="spinner-border text-primary" role="status"></div>
        </div>
        <template v-else>
          <div class="dashboard-heading">
            <div>
              <h2>Project Dashboard</h2>
            
            </div>
            <router-link
              to="/projectmanagement/index"
              class="btn btn-sm btn-outline-primary bdr-rad"
              >Manage Project</router-link
            >
          </div>

          <div class="row metric-row">
            <div class="col-md-3 mb-3">
              <div class="metric-card metric-blue">
                <span class="metric-label">Total Projects</span
                ><strong>{{ rows.length }}</strong
                ><span class="metric-note">All registered projects</span>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <div class="metric-card metric-green">
                <span class="metric-label">Active Projects</span
                ><strong>{{ activeProjects }}</strong
                ><span class="metric-note">Currently available</span>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <div class="metric-card metric-orange">
                <span class="metric-label">Planned Visits</span
                ><strong>{{ totalVisits }}</strong
                ><span class="metric-note">Across all projects</span>
              </div>
            </div>
            <div class="col-md-3 mb-3">
              <div class="metric-card metric-purple">
                <span class="metric-label">Project Sites</span
                ><strong>{{ siteCount }}</strong
                ><span class="metric-note">Unique locations</span>
              </div>
            </div>
          </div>

          <div
            v-for="item in timelineRows"
            :key="item.key"
            class="chart-card timeline-card"
          >
            <div class="chart-title">
              <div>
                
                <h4>Project Name: {{ item.label }}</h4>
                <div class="project-meta">
                  Site: {{ item.site || "-" }} <span>|</span> CRC:
                  {{ item.crc || "-" }}
                </div>
                <span class="chart-caption">{{ item.period }}</span>
                <div class="timeline-legend">
                  <span
                    ><i class="legend-swatch legend-project"></i>Project
                    Duration</span
                  ><span
                    ><i class="legend-swatch legend-visit"></i>Scheduled Visit
                    Date</span
                  ><span
                    ><i class="legend-swatch legend-completed"></i>Actual Visit
                    Date</span
                  ><span
                    ><i class="legend-swatch legend-pending"></i>Visit
                    Pending</span
                  ><span
                    ><i class="legend-swatch legend-missing"></i>Visit Not
                    Completed</span
                  >
                </div>
              </div>
            </div>
            <div class="timeline">
              <div class="timeline-head">
                <div class="timeline-project-head">#</div>
                <div class="timeline-dates">
                  <span v-for="date in item.dates" :key="date.value">{{
                    date.label
                  }}</span>
                </div>
              </div>
              <div class="timeline-row">
                <div class="timeline-project">
                  <span class="timeline-number"></span
                  ><span>Project Duration</span>
                </div>
                <div class="timeline-track">
                  <span class="timeline-grid"></span
                  ><span
                    class="timeline-bar project-bar"
                    :style="{ left: item.left + '%', width: item.width + '%' }"
                    ><small
                      >{{ item.start
                      }}{{ item.end ? " - " + item.end : "" }}</small
                    ></span
                  >
                </div>
              </div>
              <div class="timeline-row visit-row scheduled-row">
                <div class="timeline-project">
                  <span class="timeline-number"></span
                  ><span>Scheduled Visit Date</span>
                </div>
                <div class="timeline-track">
                  <span class="timeline-grid"></span
                  ><span
                    v-for="visit in item.visits"
                    :key="visit.key"
                    :class="['visit-marker', visit.barClass]"
                    :style="{
                      left: visit.left + '%',
                      width: visit.width + '%',
                    }"
                    :title="
                      visit.label +
                      ' - ' +
                      visit.start +
                      (visit.end ? ' to ' + visit.end : '')
                    "
                    ><small
                      >{{ visit.label }}: {{ visit.start
                      }}{{ visit.end ? " - " + visit.end : "" }}</small
                    ></span
                  >
                </div>
              </div>
              <div class="timeline-row visit-row">
                <div class="timeline-project">
                  <span class="timeline-number"></span
                  ><span>Actual Visit Date</span>
                </div>
                <div class="timeline-track">
                  <span class="timeline-grid"></span
                  ><span
                    v-for="visit in item.actualVisits"
                    v-if="visit.barClass"
                    :key="visit.key"
                    :class="['visit-marker', visit.barClass]"
                    :style="{
                      left: visit.left + '%',
                      width: visit.width + '%',
                    }"
                    :title="
                      visit.label +
                      ' - ' +
                      visit.start +
                      (visit.end ? ' to ' + visit.end : '')
                    "
                    ><small
                      >{{ visit.label }}: {{ visit.start
                      }}{{ visit.end ? " - " + visit.end : "" }}</small
                    ></span
                  >
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="chart-card recent-card">
            <div class="chart-title"><div><span class="chart-kicker">RECENT ACTIVITY</span><h4>Latest Projects</h4></div><router-link to="/projectmanagement/index" class="small">View all</router-link></div>
            <div class="table-responsive"><table class="table table-sm mb-0">
              <thead><tr><th>Project</th><th>Site</th><th>Sponsor</th><th>Visits</th><th>Date</th></tr></thead>
              <tbody>
                <tr v-for="row in recentRows" :key="row.id"><td><router-link :to="'/projectmanagement/view?id=' + row.id">{{ row.project_name || '-' }}</router-link></td><td>{{ row.site || '-' }}</td><td>{{ row.sponsor_name || '-' }}</td><td>{{ row.number_of_visit || 0 }}</td><td>{{ formatDate(row.created_date) }}</td></tr>
                <tr v-if="!recentRows.length"><td colspan="5" class="text-center text-muted">No project records found.</td></tr>
              </tbody>
            </table></div>
          </div> -->
        </template>
      </div>
    </div>
    <content-footer></content-footer>
  </div>
</template>

<script>
import axios from "axios";
import authService from "@/auth.service";
import TopNavbar from "../../layout/TopNavbar.vue";
import ContentFooter from "../../layout/ContentFooter.vue";

export default {
  components: { TopNavbar, ContentFooter },
  data() {
    return {
      access_token: authService.isLoggedIn(),
      loading: true,
      errorMessage: "",
      rows: [],
    };
  },
  computed: {
    activeProjects() {
      return this.rows.filter((row) => Number(row.status) !== 0).length;
    },
    totalVisits() {
      return this.rows.reduce(
        (total, row) => total + Number(row.number_of_visit || 0),
        0
      );
    },
    siteCount() {
      return new Set(
        this.rows.map((row) => String(row.site || "").trim()).filter(Boolean)
      ).size;
    },
    recentRows() {
      return this.rows.slice(0, 6);
    },
    timelineRows() {
      const source = this.rows
        .slice()
        .sort((a, b) => Number(a.id) - Number(b.id))
        .reverse();
      return source
        .map((row, index) => {
          const visits = row.visit_schedule || [];
          const datedVisits = visits.filter((visit) =>
            this.dateValue(visit.date)
          );
          const projectStart = datedVisits.length
            ? Math.min(
                ...datedVisits.map((visit) => this.dateValue(visit.date))
              )
            : null;
          const safety = visits.find((visit) =>
            String(visit.treatment_phase_label || "")
              .toLowerCase()
              .includes("safety follow-up")
          );
          const visitRanges = datedVisits.map((visit) => {
            const visitDate = this.dateValue(visit.date);
            const deviation = this.parseDeviationRange(
              visit.allowed_deviation_days
            );
            return {
              start: visitDate + deviation.min * 86400000,
              end: visitDate + deviation.max * 86400000,
            };
          });
          // End the project-duration bar at the same date as the last
          // scheduled visit range, including its allowed deviation.
          const projectEnd = visitRanges.length
            ? Math.max(...visitRanges.map((range) => range.end))
            : this.dateValue(safety && safety.date) || null;
          const firstDate = visitRanges.length
            ? Math.min(...visitRanges.map((range) => range.start))
            : projectStart;
          const lastDate = visitRanges.length
            ? Math.max(...visitRanges.map((range) => range.end))
            : projectEnd;
          const padding = 7 * 86400000;
          const timelineStart = firstDate ? firstDate - padding : Date.now();
          const timelineEnd = lastDate
            ? lastDate + padding
            : timelineStart + 30 * 86400000;
          const span = Math.max(timelineEnd - timelineStart, 86400000);
          const start = projectStart
            ? Math.max(projectStart, timelineStart)
            : timelineStart;
          const end = projectEnd
            ? Math.min(projectEnd, timelineEnd)
            : start + 86400000;
          const dates = Array.from({ length: 7 }, (_, dateIndex) => {
            const value = new Date(
              timelineStart + ((timelineEnd - timelineStart) / 6) * dateIndex
            );
            return {
              label: this.formatShortDate(value),
              value: value.getTime(),
            };
          });
          const durationStart = projectStart || timelineStart;
          const durationEnd = projectEnd || timelineEnd;
          const visitRows = visits.map((visit, visitIndex) => {
            const visitDate = this.dateValue(visit.date);
            const deviation = this.parseDeviationRange(
              visit.allowed_deviation_days
            );
            const visitRangeStart = visitDate
              ? visitDate + deviation.min * 86400000
              : null;
            const visitRangeEnd = visitDate
              ? visitDate + deviation.max * 86400000
              : null;
            const visitStart = visitDate
              ? Math.max(visitRangeStart, durationStart)
              : timelineStart;
            const visitEnd = visitDate
              ? Math.max(visitStart, Math.min(visitRangeEnd, durationEnd))
              : visitStart;
            const visitLabel =
              visit.treatment_phase_label ||
              visit.treatment_phase ||
              `Visit ${visitIndex + 1}`;
            return {
              key: `visit-${row.id || index}-${visitIndex}`,
              label: visitLabel,
              left: visitDate ? ((visitStart - timelineStart) / span) * 100 : 0,
              width: visitDate
                ? Math.max(((visitEnd - visitStart) / span) * 100, 2)
                : 2,
              start: visitDate
                ? this.formatShortDate(new Date(visitStart))
                : "Date not set",
              end: visitDate ? this.formatShortDate(new Date(visitEnd)) : "",
              barClass: "scheduled-bar",
            };
          });
          const actualVisits = [];
          visits.forEach((visit, visitIndex) => {
            const visitDate = this.dateValue(visit.date);
            const rawDates =
              row.completed_visit_dates &&
              row.completed_visit_dates[visitIndex + 1];
            const actualDates = (
              Array.isArray(rawDates) ? rawDates : rawDates ? [rawDates] : []
            )
              .map((date) => this.dateValue(date))
              .filter(Boolean);
            const deviation = this.parseDeviationRange(
              visit.allowed_deviation_days
            );
            const allowedStart = visitDate
              ? visitDate + deviation.min * 86400000
              : null;
            const allowedEnd = visitDate
              ? visitDate + deviation.max * 86400000
              : null;
            const visitLabel =
              visit.treatment_phase_label ||
              visit.treatment_phase ||
              `Visit ${visitIndex + 1}`;
            if (actualDates.length) {
              const actualGroups = [];
              actualDates
                .sort((first, second) => first - second)
                .forEach((actualDate) => {
                  const lastGroup = actualGroups[actualGroups.length - 1];
                  if (
                    lastGroup &&
                    actualDate - lastGroup[lastGroup.length - 1] <= 86400000
                  )
                    lastGroup.push(actualDate);
                  else actualGroups.push([actualDate]);
                });
              actualGroups.forEach((actualGroup, actualIndex) => {
                const actualStart = actualGroup[0];
                const actualEnd = actualGroup[actualGroup.length - 1];
                const markerStart = Math.min(
                  Math.max(actualStart, durationStart),
                  durationEnd
                );
                const markerEnd = Math.max(
                  markerStart,
                  Math.min(actualEnd, durationEnd)
                );
                actualVisits.push({
                  key: `actual-visit-${
                    row.id || index
                  }-${visitIndex}-${actualIndex}`,
                  label: visitLabel,
                  left: ((markerStart - timelineStart) / span) * 100,
                  width: Math.max(((markerEnd - markerStart) / span) * 100, 2),
                  start: this.formatShortDate(new Date(markerStart)),
                  end:
                    markerEnd > markerStart
                      ? this.formatShortDate(new Date(markerEnd))
                      : "",
                  barClass: "completed-bar",
                });
              });
              return;
            }
            const today = new Date().setHours(0, 0, 0, 0);
            const barClass =
              !allowedEnd || allowedEnd < today
                ? "missing-bar"
                : allowedStart && allowedStart <= today
                ? "upcoming-bar"
                : "";
            const markerStart = allowedStart
              ? Math.max(allowedStart, durationStart)
              : null;
            const markerEnd = allowedEnd
              ? Math.max(markerStart, Math.min(allowedEnd, durationEnd))
              : markerStart;
            actualVisits.push({
              key: `actual-visit-${row.id || index}-${visitIndex}`,
              label: visitLabel,
              left: markerStart
                ? ((markerStart - timelineStart) / span) * 100
                : 0,
              width:
                markerStart && markerEnd
                  ? Math.max(((markerEnd - markerStart) / span) * 100, 2)
                  : 2,
              start: markerStart
                ? this.formatShortDate(new Date(markerStart))
                : "Not visited",
              end: markerEnd ? this.formatShortDate(new Date(markerEnd)) : "",
              barClass,
            });
          });
          return {
            key: `project-${row.id || index}`,
            number: index + 1,
            label: row.project_name || "Untitled Project",
            site: row.site,
            crc: row.crc_name,
            left: ((start - timelineStart) / span) * 100,
            width: Math.max(((end - start) / span) * 100, 3),
            start: projectStart
              ? this.formatShortDate(new Date(projectStart))
              : "Date not set",
            end: projectEnd ? this.formatShortDate(new Date(projectEnd)) : "",
            period: `${this.formatShortDate(
              new Date(timelineStart)
            )} - ${this.formatShortDate(new Date(timelineEnd))}`,
            dates,
            visits: visitRows,
            actualVisits,
          };
        })
        .filter(Boolean);
    },
  },
  mounted() {
    this.loadDashboard();
  },
  methods: {
    async loadDashboard() {
      try {
        const { data } = await axios.get("/projectmanagement/indexload", {
          headers: { Authorization: "Bearer " + this.access_token },
        });
        this.rows = data.status === 200 ? data.data || [] : [];
      } catch (error) {
        this.errorMessage = "Unable to load project dashboard.";
        console.error(error.response || error);
      } finally {
        this.loading = false;
      }
    },
    dateValue(value) {
      const time = value ? new Date(value + "T00:00:00").getTime() : NaN;
      return Number.isNaN(time) ? null : time;
    },
    parseDeviationRange(value) {
      const text = String(value || "").trim();
      const plusMinus = text.match(/\+\/\-\s*(\d+)/);
      if (plusMinus)
        return { min: -Number(plusMinus[1]), max: Number(plusMinus[1]) };
      const plus = text.match(/\+\s*(\d+)/);
      if (plus) return { min: 0, max: Number(plus[1]) };
      const minus = text.match(/-\s*(\d+)/);
      if (minus) return { min: -Number(minus[1]), max: 0 };
      return { min: 0, max: 0 };
    },
    formatShortDate(value) {
      return value.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
      });
    },
    formatDate(value) {
      if (!value) return "-";
      const parts = String(value).split("-");
      return parts.length === 3
        ? `${parts[2].slice(0, 2)}/${parts[1]}/${parts[0]}`
        : value;
    },
  },
};
</script>

<style scoped>
.project-dashboard {
  background: #eef8ff;
  min-height: calc(100vh - 60px);
}
.dashboard-content {
  padding-bottom: 100px;
}
.dashboard-heading {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0px 4px 10px;
}
.eyebrow,
.chart-kicker {
  color: #1677ff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  margin: 0 0 4px;
}
.dashboard-heading h2 {
  color: #14365d;
  font-size: 28px;
  font-weight: 700;
  margin: 0;
}
.subtitle,
.chart-caption {
  color: #718399;
  font-size: 13px;
  margin: 6px 0 0;
}
.metric-card,
.chart-card {
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 8px 22px rgba(31, 73, 125, 0.1);
}
.metric-card {
  padding: 18px 20px;
  border-left: 5px solid #1677ff;
  min-height: 116px;
}
.metric-green {
  border-color: #22a06b;
}
.metric-orange {
  border-color: #f59e0b;
}
.metric-purple {
  border-color: #8b5cf6;
}
.metric-label {
  color: #718399;
  display: block;
  font-size: 13px;
}
.metric-card strong {
  color: #14365d;
  display: block;
  font-size: 30px;
  line-height: 1.2;
  margin: 5px 0;
}
.metric-note {
  color: #99a8b8;
  font-size: 11px;
}
.chart-card {
  padding: 20px;
}
.chart-title {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 12px;
}
.chart-title h4 {
  color: #14365d;
  font-size: 18px;
  margin: 0;
}
.chart-wrap {
  height: 270px;
  position: relative;
}
.chart-bars {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 13px;
}
.bar-row {
  align-items: center;
  display: flex;
  gap: 9px;
  min-width: 0;
}
.bar-label {
  color: #50657b;
  flex: 0 0 34%;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bar-track {
  background: #edf2f7;
  border-radius: 8px;
  flex: 1;
  height: 12px;
  overflow: hidden;
}
.bar-fill {
  border-radius: 8px;
  display: block;
  height: 100%;
  min-width: 4%;
}
.blue-fill {
  background: #1677ff;
}
.orange-fill {
  background: #f59e0b;
}
.bar-row b {
  color: #14365d;
  font-size: 12px;
  min-width: 20px;
  text-align: right;
}
.empty-chart {
  color: #9aaabd;
  font-size: 13px;
  text-align: center;
}
.timeline-controls {
  display: flex;
  gap: 6px;
}
.timeline-controls-global {
  justify-content: flex-end;
  margin: 0 0 10px;
}
.recent-card {
  margin-bottom: 20px;
}
.recent-card th {
  color: #63758a;
  font-size: 12px;
  border-top: 0;
}
.recent-card td {
  color: #30465f;
  font-size: 13px;
  vertical-align: middle;
}
.recent-card a {
  color: #1677ff;
}
.dashboard-loading {
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.timeline-card {
  margin-bottom: 24px;
  overflow-x: auto;
}
.timeline {
  min-width: 760px;
}
.timeline-head,
.timeline-row {
  display: grid;
  grid-template-columns: 185px 1fr;
}
.timeline-head {
  border-bottom: 1px solid #d9e4ef;
  color: #63758a;
  font-size: 11px;
  font-weight: 700;
  padding-bottom: 8px;
}
.timeline-project-head {
  padding-left: 4px;
}
.timeline-dates {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
}
.timeline-dates span {
  text-align: center;
}
.timeline-row {
  min-height: 58px;
  border-bottom: 1px solid #edf2f7;
}
.timeline-project {
  align-items: center;
  color: #30465f;
  display: flex;
  font-size: 12px;
  overflow: hidden;
  padding: 0 8px 0 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.timeline-track {
  background: repeating-linear-gradient(
    to right,
    transparent 0,
    transparent calc(14.285% - 1px),
    #e7edf4 calc(14.285% - 1px),
    #e7edf4 14.285%
  );
  position: relative;
}
.timeline-grid {
  inset: 0;
  position: absolute;
}
.timeline-bar {
  border-radius: 4px;
  box-shadow: 0 3px 7px rgba(22, 133, 213, 0.2);
  height: 22px;
  max-width: 92%;
  min-width: 48px;
  position: absolute;
  top: 8px;
}
.project-bar {
  background: linear-gradient(90deg, #39a2ed, #1685d5);
}
.completed-bar {
  background: #22a06b;
}
.upcoming-bar {
  background: #f59e0b;
}
.missing-bar {
  background: #dc3545;
}
.timeline-bar small {
  color: #fff;
  font-size: 10px;
  left: 8px;
  line-height: 22px;
  position: absolute;
  white-space: nowrap;
}
.visit-marker {
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  height: 14px;
  min-width: 16px;
  position: absolute;
  top: 37px;
}
.visit-marker small {
  color: #fff;
  font-size: 8px;
  left: 5px;
  line-height: 14px;
  position: absolute;
  white-space: nowrap;
}
.timeline-arrow {
  align-items: center;
  background: #245a87;
  border: 1px solid #245a87;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 20px;
  height: 36px;
  justify-content: center;
  line-height: 1;
  margin-left: 5px;
  padding: 0 0 2px;
  transition: 0.15s ease;
  width: 36px;
}
.timeline-arrow:hover {
  background: #17466d;
  border-color: #17466d;
  color: #fff;
}
.timeline-project {
  gap: 7px;
}
.timeline-number {
  color: #718399;
  flex: 0 0 18px;
  font-size: 11px;
  text-align: right;
}
.timeline-legend {
  align-items: center;
  color: #718399;
  display: flex;
  flex-wrap: wrap;
  font-size: 10px;
  gap: 12px;
  margin-top: 8px;
}
.timeline-legend span {
  align-items: center;
  display: inline-flex;
  gap: 4px;
}
.legend-swatch {
  border-radius: 3px;
  display: inline-block;
  height: 8px;
  width: 18px;
}
.legend-project {
  background: #1685d5;
}
.legend-visit {
  background: #f59e0b;
}
.legend-completed {
  background: #22a06b;
}
.legend-missing {
  background: #dc3545;
}
.timeline-head {
  border-bottom: 0;
}
.timeline-row {
  border-bottom: 0;
  min-height: 25px;
}
.timeline-bar {
  top: 1px;
}
.visit-marker {
  height: 22px;
  top: 1px;
}
.visit-marker small {
  line-height: 22px;
}
.project-meta {
  color: #63758a;
  font-size: 12px;
  margin-top: 3px;
}
.project-meta span {
  color: #b1bdc9;
  margin: 0 5px;
}
.scheduled-row .timeline-project {
  color: #30465f;
}
.scheduled-bar {
  background: #000;
}
.legend-visit {
  background: #000;
}
.legend-pending {
  background: #f59e0b;
}
@media (max-width: 767px) {
  .dashboard-heading {
    align-items: start;
    flex-direction: column;
    gap: 14px;
  }
  .chart-wrap {
    height: 240px;
  }
}
</style>
